import { Tabs, TabsProps } from 'antd';
import { FC } from 'react';

import { SearchConsoleAnalyticsDimensions, SearchConsoleAnalyticsDimensionsKeys, SearchConsoleAnalyticsRowKeysColor } from '@/modules/Domains';

import { DimensionTable } from './DimensionTable';

import './SearchConsoleAnalyticsTablesTabs.scss';

const analyseTabsLabels: Record<SearchConsoleAnalyticsDimensionsKeys, string> = {
  queries: 'Запити',
  pages: 'Сторінки',
  countries: 'Країни',
  devices: 'Пристрої',
  searchAppearances: 'Вигляд у результатах пошуку',
  dates: 'Дати',
};

interface Props {
  dimensionsRows: SearchConsoleAnalyticsDimensions;
  itemsColor: SearchConsoleAnalyticsRowKeysColor;
}

export const SearchConsoleAnalyticsTablesTabsView: FC<Props> = ({ dimensionsRows, itemsColor }) => {
  const items: NonNullable<TabsProps['items']> = Object.entries(dimensionsRows).map(([dimension, row]) => ({
    key: dimension,
    label: analyseTabsLabels[dimension as SearchConsoleAnalyticsDimensionsKeys],
    style: { width: '100%' },
    children: <DimensionTable
      itemsColor={ itemsColor }
      dimension={ dimension as SearchConsoleAnalyticsDimensionsKeys }
      rows={ row }
    />
  }));

  return (
    <Tabs
      id="search-console-analytics-tables-tabs"
      defaultActiveKey="queries"
      centered
      items={ items }
    />
  );
};

